import { render, staticRenderFns } from "./OutboundPage.vue?vue&type=template&id=648bc217&"
import script from "./OutboundPage.vue?vue&type=script&lang=ts&"
export * from "./OutboundPage.vue?vue&type=script&lang=ts&"
import style0 from "./OutboundPage.vue?vue&type=style&index=0&id=648bc217&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports